import { defineMessages } from 'react-intl';

export default defineMessages({
  add100: {
    defaultMessage: 'Add 100 Todos',
    id: 'todos.buttons.add100'
  },
  clearAll: {
    defaultMessage: 'Clear All',
    id: 'todos.buttons.clearAll'
  },
  clearCompleted: {
    defaultMessage: 'Clear Completed',
    id: 'todos.buttons.clearCompleted'
  }
});



// WEBPACK FOOTER //
// ./src/common/todos/buttonsMessages.js